<!-- IoT-User-Frontend/src/components/Footer.vue -->
<template>
    <!-- Footer Area -->
    <footer class="footer-area">
        <div class="container">
            <div class="row justify-content-center">
                <div class="footer-up">
                    <div class="row">
                        <!-- Contact Information -->
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <h6><i class="las la-id-card" aria-hidden="true"></i> Contact Information</h6>
                            <div class="contact-info">
                                <p><i class="las la-map-marker-alt" aria-hidden="true"></i> <b>Location:</b> {{
                                    contact_info.location }}</p>
                                <p><i class="las la-phone" aria-hidden="true"></i> <b>Phone:</b> {{ contact_info.phone
                                    }}
                                </p>
                                <p><i class="las la-envelope" aria-hidden="true"></i> <b>Email:</b> {{
                                    contact_info.email }}
                                </p>
                                <p><i class="las la-clock" aria-hidden="true"></i> <b>Opening Hours:</b> {{
                                    contact_info.opening_hour }}</p>
                            </div>
                        </div>

                        <!-- Quick Links -->
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 quick-links text-center">
                            <h6><i class="las la-link" aria-hidden="true"></i>Quick Links</h6>
                            <!-- Row for 2 columns of links -->
                            <div class="row text-start justify-content-center">
                                <!-- Left column -->
                                <div class="col-5">
                                    <ul>
                                        <li>
                                            <router-link :to="{ name: 'About' }">
                                                <i class="las la-info-circle"></i> About Us
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'ProjectsPage' }">
                                                <i class="las la-project-diagram"></i> Our Projects
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>

                                <!-- Right column -->
                                <div class="col-5">
                                    <ul>
                                        <li>
                                            <router-link :to="{ name: 'Contact' }">
                                                <i class="las la-phone-volume"></i> Contact
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'FAQ' }">
                                                <i class="las la-question-circle"></i> FAQ
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Newsletter Subscription -->
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div class="subscribe-form">
                                <h6><i class="las la-newspaper" aria-hidden="true"></i> Subscribe to Our Newsletter</h6>
                                <div class="newsletter">
                                    <form @submit.prevent>
                                        <div class="input-group">
                                            <input type="email" placeholder="Enter your email"
                                                aria-label="Email address" required>
                                            <button type="submit" aria-label="Subscribe to newsletter"><i
                                                    class="las la-envelope"></i></button>
                                        </div>
                                    </form>
                                    <p>Stay updated with our latest projects and news.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom row justify-content-center">
            <div class="container justify-content-center">
                <div class="row justify-content-between align-items-center text-center text-md-start">
                    <div class="col-md-4 mb-2 mb-md-0">
                        <p>© {{ currentYear }} ASDL IoT. All rights reserved.</p>
                    </div>
                    <div class="col-md-4 mb-2 mb-md-0">
                        <router-link :to="{ name: 'FAQ', hash: '#terms-anchor' }" aria-label="Terms and Conditions">
                            Terms &amp; Conditions
                        </router-link>
                        |
                        <a href="#" aria-label="Privacy Policy">Privacy Policy</a>
                    </div>
                    <div class="col-md-4 text-md-end">
                        <div class="social-area">
                            <a href="https://www.linkedin.com/company/asdl-iot" target="_blank" aria-label="LinkedIn"><i
                                    class="lab la-linkedin"></i></a>
                            <a href="https://twitter.com/ASDL_IOT" target="_blank" aria-label="Twitter"><i
                                    class="lab la-twitter"></i></a>
                            <a href="https://github.com/ASDL-IOT" target="_blank" aria-label="GitHub"><i
                                    class="lab la-github"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            contact_info: {},
            currentYear: new Date().getFullYear()
        };
    },
    async mounted() {
        try {
            const response = await axios.get("/assets/data/contact_info.json");
            this.contact_info = response.data.contact_info;
        } catch (error) {
            console.error("Error loading contact information:", error);
        }
    }
};
</script>
<style scoped>
/* ======================== 
   GENERAL FOOTER STYLES 
======================== */

.footer-area {
    background-color: #0b1c2c;
    color: #ffffff;
    padding: 0;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.footer-area h6 {
    font-weight: 600;
    margin-bottom: 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.footer-up {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
}

.footer-bottom {
    background-color: #08131f;
    padding: 20px 0;
    font-size: 13px;
    color: #ccc;
    width: 100%;
}

/* Container Adjustments */
div.container {
    margin: 0 auto;
    padding: 24px;
    max-width: 1200px;
    width: 100%;
}

/* Column and Margin Overrides */
div.col-lg-4.col-md-6.col-sm-12.mb-4 {
    margin: 0;
    margin-bottom: 0 !important;
}

.mb-4 {
    margin-bottom: 0 !important;
}

/* ======================== 
   CONTACT INFO SECTION 
======================== */

.contact-info p {
    margin-bottom: 10px;
}

.contact-info i {
    margin-right: 8px;
    color: #6cbf84;
    font-size: 16px;
    vertical-align: middle;
}

/* ======================== 
   QUICK LINKS SECTION 
======================== */

.quick-links {
    text-align: center;
}

.quick-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.quick-links li {
    margin-bottom: 10px;
}

.quick-links a {
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
}

.quick-links a:hover {
    color: #6cbf84;
}

.quick-links i {
    color: #6cbf84;
    font-size: 16px;
    margin-right: 0;
    vertical-align: middle;
}

@media (max-width: 576px) {
    .quick-links .col-6 {
        width: 100%;
        margin-bottom: 10px;
    }
}

div.row.text-start.justify-content-center {
    margin: 0;
}

/* ======================== 
   SUBSCRIBE SECTION 
======================== */

div.newsletter {
    margin: 14px 0 10px 20px;
}

.subscribe-form p {
    margin-bottom: 10px;
}

.subscribe-form .input-group {
    display: flex;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 10px;
}

.subscribe-form input {
    flex: 1;
    padding: 10px;
    border: none;
    outline: none;
    font-size: 14px;
}

.subscribe-form button {
    background-color: #6cbf84;
    color: #ffffff;
    border: none;
    width: 45px;
    height: 45px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    padding-left: 6px;
}

.subscribe-form button:hover {
    background-color: #5aaa72;
}

.subscribe-form button i {
    font-size: 20px;
    line-height: 1;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ======================== 
   FOOTER BOTTOM STYLES 
======================== */

.footer-bottom .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
}

.footer-bottom a {
    color: #ccc;
    text-decoration: none;
    margin: 0 5px;
}

.footer-bottom a:hover {
    color: #6cbf84;
}

.footer-bottom p {
    font-size: 15px;
    color: #95999e;
    margin: 0;
}

.social-area a {
    color: #ccc;
    margin-left: 10px;
    font-size: 18px;
    transition: color 0.3s;
}

.social-area a:hover {
    color: #6cbf84;
}

/* ======================== 
   ICON FONT SUPPORT 
======================== */

.la-id-card:before,
.la-newspaper:before {
    color: #6cbf84;
    font-size: 16px;
    margin-right: 8px;
    vertical-align: middle;
}

.la {
    font-family: 'Line Awesome Free';
    font-weight: 900;
}

/* Additional icon-specific styling */
.quick-links i[data-v-40ab164b] {
    color: #6cbf84;
    font-size: 16px;
    margin-right: 8px;
    vertical-align: middle;
}
</style>
